import { render, staticRenderFns } from "./RegDocs.vue?vue&type=template&id=3ce87e98"
import script from "./RegDocs.vue?vue&type=script&lang=js"
export * from "./RegDocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports